export const CREATE_RESULT = "CREATE_RESULT";
export const CREATE_RESULT_SUCCESS = "CREATE_RESULT_SUCCESS";
export const CREATE_RESULT_FAILURE = "CREATE_RESULT_FAILURE";

export const UPDATE_RESULT = "UPDATE_RESULT";
export const UPDATE_RESULT_SUCCESS = "UPDATE_RESULT_SUCCESS";
export const UPDATE_RESULT_FAILURE = "UPDATE_RESULT_FAILURE";

export const MARK_RESULT = "MARK_RESULT";
export const MARK_RESULT_SUCCESS = "MARK_RESULT_SUCCESS";
export const MARK_RESULT_FAILURE = "MARK_RESULT_FAILURE";

export const GET_RESULT_BY_TEST_ID = "GET_RESULT_BY_TEST_ID";
export const GET_RESULT_BY_TEST_ID_SUCCESS = "GET_RESULT_BY_TEST_ID_SUCCESS ";
export const GET_RESULT_BY_TEST_ID_FAILURE = "GET_RESULT_BY_TEST_ID_FAILURE";

export const GET_RESULTS_COUNT = "GET_RESULTS_COUNT";
export const GET_RESULTS_COUNT_SUCCESS = "GET_RESULTS_COUNT_SUCCESS ";
export const GET_RESULTS_COUNT_FAILURE = "GET_RESULTS_COUNT_FAILURE";

export const FETCH_RESULTS_BY_CANDIDATE_ID = "FETCH_RESULTS_BY_CANDIDATE_ID";
export const FETCH_RESULTS_BY_CANDIDATE_ID_SUCCESS =
  "FETCH_RESULTS_BY_CANDIDATE_ID_SUCCESS";
export const FETCH_RESULTS_BY_CANDIDATE_ID_FAILURE =
  "FETCH_RESULTS_BY_CANDIDATE_ID_FAILURE";
